import data from "./data.js";
window.sedData = data;

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({ ignoreMobileResize: true });

const StudentJS = {
  list: function () {
    function addList() {
      let listItem;
      for (let i = 0; i < sedData.length; i++) {
        let name = sedData[i].name[1].toLowerCase().replace(/[\s-]/g, "");
        listItem = `
                    <div class="swiper-slide">
                        <a href="./studentsDetail?id=${sedData[i].id}?idx=${i}" data-student="${sedData[i].id}">
                            <div class="img_wrap">
                                <img src="./assets/images/students/${name}/${name}_p.png" alt="">
                                <img src="./assets/images/students/${name}/${name}_t.jpg" alt="">
                            </div>
                        </a>
                    </div>
                `;
        $(".student_list .swiper-wrapper").append(listItem);
      }
    }
    addList();

    const swiper = new Swiper(".student_list", {
      freeMode: true,
      parallax: true,
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",
      coverflowEffect: {
        rotate: 0,
        stretch: 2,
      },
      spaceBetween: 40,
      breakpoints: {
        768: {
          spaceBetween: 120,
        },
      },
      on: {
        slideChange: function () {
          let idx = this.realIndex;
          if (idx < 10) {
            $("#student_number").text(`(0${idx + 1})`);
          } else {
            $("#student_number").text(`(${idx + 1})`);
          }
          gsap.to("#student_name", 0.3, {
            text: {
              value: sedData[idx].name[1],
            },
            delay: 0,
          });
        },
      },
    });
  },

  detail: function () {
    const id = location.href.split("id=")[1].split("?num")[0];
    const idx = location.href.split("idx=")[1];
    const name = sedData[idx].name[1].toLowerCase().replace(/[\s-]/g, "");
    let title,
      img_v,
      img_b,
      video,
      message,
      page,
      number = sedData.indexOf(sedData[idx]);

    if (number < 10) {
      number = "0" + (number + 1);
      $(".studentsDetail .detail_hd .num").text(`( ${number} )`);
    } else {
      number = number;
      $(".studentsDetail .detail_hd .num").text(`( ${number} )`);
    }

    $(".studentsDetail .detail_hd .name").text(`${sedData[idx].name[1]}`);

    title = `
            <span>${sedData[idx].title}</span>
        `;

    $(".studentsDetail .number").text(`( ${sedData} )`);

    $(".studentsDetail #tit").attr("data-tit", sedData[idx].title);
    $(".studentsDetail #tit").append(title);
    img_v = `
            <img src="./assets/images/students/${name}/${name}_t.jpg" alt="">
        `;
    $(".studentsDetail .visual_img").append(img_v);
    $(".studentsDetail .visual_img").addClass("show");

    if (sedData[idx].message != "") {
      message = `
                <div class="message">
                    <p>${sedData[idx].message}</p>
                </div>
            `;
      $(".studentsDetail .desc .inner").prepend(message);
    }

    $("#st_name").text(`${sedData[idx].name[0]} ( ${sedData[idx].name[1]} )`);
    $("#st_tit").text(`${sedData[idx].title}`);
    $("#st_desc").text(`${sedData[idx].description}`);
    $("#st_email").text(`${sedData[idx].email}`);

    if (sedData[idx].video) {
      video = `
                <div class="video_wrap fade anim">
                    <button type="button" class="play_btn modal_btn video_btn" data-modal="videoModal">
                        <span>PLAY VIDEO</span>
                    </button>
                    <img src="./assets/images/students/${name}/${name}_vt.jpg" alt="">
                    <span class="bd"></span>
                    <span class="bd"></span>
                    <span class="bd"></span>
                    <span class="bd"></span>
                    <div class="dim"></div>
                </div>
            `;

      $("#videoModal video").attr(
        "poster",
        `./assets/images/students/${name}/${name}_vt.jpg`
      );
      $("#videoModal video source").attr(
        "src",
        `./assets/images/students/${name}/${name}_v.mp4`
      );

      $("#st_video")[0].load();

      $(".studentsDetail .content").append(video);
    }

    for (let i = 0; i < 4; i++) {
      img_b = `
              <div class="img_wrap fade anim">
                  <img src="./assets/images/students/${name}/${name}_b${i + 1}.jpg" alt="">
              </div>
            `;
      $(".studentsDetail .content").append(img_b);
    }
    if (sedData[idx].book) {
      for (let i = 0; i < 3; i++){
        page = `
                <div class="swiper-slide">
                  <img src="./assets/images/students/${name}/${name}_r${i+1}.jpg" />
                </div>
              `;
        $("#bookModal .swiper-wrapper").append(page);
      }
      const bookSwiper = new Swiper("#bookModal .swiper", {
        slidesPerView: "1",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }else{
      $(".book_btn_txt").remove();
      $(".open_book_btn").remove();
    }
  },

  ranList: function () {
    const numbers = [];
    for (let i = 0; i < sedData.length; i += 1) {
      numbers.push(i + 1);
    }

    const answer = [];
    for (let i = 0; i < 3; i += 1) {
      const idx = Math.floor(Math.random() * (numbers.length - i));
      answer.push(numbers[idx]);
      numbers.splice(idx, 1);
    }

    let dummy;
    for (let i = 0; i < answer.length; i++) {
      console.log(i);
      let name = sedData[answer[i]].name[1].toLowerCase().replace(/[\s-]/g, "");
      dummy = `
            <a class="rand_student_card fade anim" href="./studentsDetail?id=${sedData[answer[i]].id}?idx=${answer[i]}" data-student="${sedData[answer[i]].id}">
              <div class="img_box">
                <img src="./assets/images/students/${name}/${name}_t.jpg">
              </div>
              <div class="txt">
                <h3>${sedData[answer[i]].title}</h3>
                <p>${sedData[answer[i]].description}</p>
              </div>
            </a>
          `;
      if (i == 0) {
        $(".rand_student.rand1").append(dummy);
      } else if(i == 1) {
        $(".rand_student.rand2").append(dummy);
      } else if(i == 2) {
        $(".rand_student.rand3").append(dummy);
      }
    }
  },

  init: function () {
    $(".student_list").length !== 0 ? this.list() : undefined;
    $(".studentsDetail").length !== 0 ? this.detail() : undefined;
    $(".rand_student_list").length !== 0 ? this.ranList() : undefined;
  },
};

document.addEventListener("DOMContentLoaded", ready);

function ready() {
  StudentJS.init();
}
